import styled from 'styled-components';
import { DatePicker as AntdDatePicker } from 'antd';

export const DatePicker = styled(AntdDatePicker)`
  width: 100%;
  height: 2rem;
  //border: 1px solid #e8e8eb;
  font-family: Figtree, 'Noto Sans Thai', sans-serif !important;
`;
